var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{attrs:{"loading":_vm.loading,"color":"primary"},on:{"click":_vm.importToMongoDb}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("mdi-application-import")]),_c('p',{staticClass:"ma-0 mb-n1"},[_vm._v(_vm._s(_vm.$t('mongo.import.button')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }